var STORE_ITEM_NAME = 'store';
export var getState = function () {
    try {
        var serializedState = window.localStorage.getItem(STORE_ITEM_NAME);
        if (!serializedState) {
            return null;
        }
        return JSON.parse(serializedState);
    }
    catch (e) {
        return null;
    }
};
export var saveState = function (item) {
    if (typeof item === 'object') {
        // Only persist auth and localization — game/player state contains
        // protobuf class instances that cannot be safely JSON-serialized.
        var safeSlices = {
            userAuthorization: item.userAuthorization,
            playerAuthorization: item.playerAuthorization,
            localization: item.localization,
        };
        try {
            window.localStorage.setItem(STORE_ITEM_NAME, JSON.stringify(safeSlices));
        }
        catch (e) {
            // quota exceeded or serialization error — fail silently
        }
    }
};
export var removeState = function () {
    window.localStorage.removeItem(STORE_ITEM_NAME);
};
